export default __webpack_public_path__ + "static/media/icon_home_top_laptop.0259a7b3.svg";